import { Quote, PurchaseMethods, ShowroomService } from '@sm360/widget-commons-vehicle';
import * as protectionsTypes from 'protections/actions/protectionsActionTypes.js';

const { PurchaseMethodsActions, PurchaseMethodsService } = PurchaseMethods;

const { QuoteActions, QuoteItemCategoryService } = Quote;

function setProtections(protections) {
    return { type: protectionsTypes.SET_PROTECTIONS, protections };
}

function getQuoteProtections(quoteId) {
    return (dispatch) => {
        return ShowroomService.loadQuoteProtections(quoteId)
            .then((quoteProtections) => {
                dispatch(setProtections(quoteProtections));
            })
            .catch((error) => {
                throw error;
            });
    };
}

function loadQuote(quoteId) {
    return (dispatch) => {
        return ShowroomService.loadQuote(quoteId)
            .then((quote) => {
                dispatch(QuoteActions.setQuote(quote));
                dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(quote.vehicle.purchaseMethods));
                dispatch(getQuoteProtections(quoteId));
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function loadQuoteProtections(quoteId) {
    return (dispatch, getState) => {
        const state = getState();
        if (!state.quote || !state.quote.id) {
            dispatch(loadQuote(quoteId));
        } else {
            dispatch(getQuoteProtections(quoteId));
        }
    };
}

export function openProtectionCategory(protectionCategory) {
    return (dispatch, getState) => {
        const state = getState();
        dispatch(
            setProtections(
                QuoteItemCategoryService.selectQuoteItemCategory(state.protections, protectionCategory, false)
            )
        );
    };
}

export function nextPreviousProtectionCategory(protectionCategory, previous, declineProtections) {
    return (dispatch, getState) => {
        let state = getState();

        dispatch(
            setProtections(
                QuoteItemCategoryService.selectNextPreviousQuoteItemCategory(
                    state.protections,
                    protectionCategory,
                    previous,
                    declineProtections
                )
            )
        );

        state = getState();
        dispatch(
            PurchaseMethodsActions.loadPurchaseMethodsSuccess(
                PurchaseMethodsService.resetProtections(state.purchaseMethods, state.protections)
            )
        );
    };
}

export function selectProtectionPackage(protectionCategory, protectionPackage) {
    return (dispatch, getState) => {
        let state = getState();

        dispatch(
            setProtections(
                QuoteItemCategoryService.selectQuoteItemPackage(
                    state.protections,
                    protectionCategory,
                    protectionPackage
                )
            )
        );

        state = getState();
        const newPurchaseMethods = PurchaseMethodsService.resetProtections(state.purchaseMethods, state.protections);
        dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(newPurchaseMethods));
        dispatch(QuoteActions.setQuotePurchaseMethods(newPurchaseMethods));
    };
}

export default {
    loadQuoteProtections,
    openProtectionCategory,
    nextPreviousProtectionCategory,
    selectProtectionPackage,
};



// WEBPACK FOOTER //
// ./src/actions/protectionsActions.js